import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Grid, GridItem, Select, Input } from "@chakra-ui/react"
import { format } from "date-fns";

import { getCurrencySymbol } from "@/utils/currency";
import { COLORS, INVOICE_STATUS } from "@/common/constants";

export type ShipOperatorInvoiceDataConfirmation = {
    invoiceId: string, // internal UID
    invoiceNumber: string, // user-facing
    sequenceID: string,
    inspectionDate: Date | string,
    invoiceDate: Date | string,
    vesselName: string,
    currency: string, // "IDR" / "USD"
    totalAmount: number,
}

type ModalShipOperatorInvoiceConfirmProps = {
    isOpen: boolean,
    onClose: () => void,
    handleCancel: () => void,
    handleConfirm: () => void
    dataConfirmation?: ShipOperatorInvoiceDataConfirmation,
    approvalStatus: string // of number
    handleChangeApprovalStatus: (status: string) => void, // string of number, can easily be converted to number
    handleChangeNote: (note: string) => void,
    errorMessageApproval: string,
    errorMessageNote: string,
}

const ModalShipOperatorInvoiceConfirm = ({ isOpen, onClose, handleCancel, handleConfirm, approvalStatus, dataConfirmation, handleChangeApprovalStatus, handleChangeNote, errorMessageApproval, errorMessageNote }: ModalShipOperatorInvoiceConfirmProps) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered size='xl'>
            <ModalOverlay />
            <ModalContent borderRadius={15} padding={'10px'}>
                <ModalHeader>Invoice Approval</ModalHeader>
                <ModalCloseButton onClick={handleCancel} _focus={{ outline: 'none', boxShadow: 'none' }} />
                <ModalBody marginTop={5}>
                    <Grid templateColumns='repeat(2, 1fr)' gap={6}>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Order Number</p>
                            <p>{dataConfirmation?.sequenceID ?? '-'}</p>
                        </GridItem>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Inspection Date</p>
                            <p>{dataConfirmation?.inspectionDate ? format(dataConfirmation?.inspectionDate, 'dd-MM-yyyy') : '-'}</p>
                        </GridItem>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Invoice ID</p>
                            <p>{dataConfirmation?.invoiceNumber ?? '-'}</p>
                        </GridItem>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Invoice Date</p>
                            <p>{dataConfirmation?.invoiceDate ? format(dataConfirmation?.invoiceDate, 'dd-MM-yyyy') : '-'}</p>
                        </GridItem>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Vessel Name</p>
                            <p>{dataConfirmation?.vesselName ?? '-'}</p>
                        </GridItem>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Total Amount</p>
                            <p>{dataConfirmation?.currency ? getCurrencySymbol(dataConfirmation.currency, dataConfirmation.totalAmount) : '-'}</p>
                        </GridItem>
                    </Grid>
                    <Select fontSize="12px" cursor="pointer" marginTop={10} marginBottom={5} onChange={(e) => handleChangeApprovalStatus(e.target.value)} borderColor={errorMessageApproval ? 'red' : 'gray'}>
                        <option key='none' value={-1}>Please select...</option>
                        <option key='approved' value={INVOICE_STATUS.APPROVED}>Approve</option>
                        <option key='rejected' value={INVOICE_STATUS.REJECTED}>Request Revision</option>
                    </Select>
                    {errorMessageApproval && <p style={{ fontSize: '14px', color: 'red' }}>{errorMessageApproval}</p>}
                    {approvalStatus === '3' && <>
                        <p style={{ marginBottom: 5, fontWeight: 'bold' }}>Note</p>
                        <Input placeholder="Input your note here" onChange={(e) => handleChangeNote(e.target.value)} borderColor={errorMessageNote ? 'red' : 'gray'} />
                        {errorMessageNote && <p style={{ fontSize: '14px', color: 'red' }}>{errorMessageNote}</p>}
                    </>}
                </ModalBody>
                <ModalFooter style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: 10 }}>
                    <Button onClick={handleCancel} borderColor='#D0D5DD' bgColor='white'>Cancel</Button>
                    <Button onClick={handleConfirm} bgColor={COLORS.BUTTON.BACKGROUND} color={COLORS.BUTTON.FOREGROUND}>Confirm</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ModalShipOperatorInvoiceConfirm;